import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchO365Licenses } from '../../../features/o365/O365Slice';

//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';

//Material UI Imports
import {
  Box,
  Skeleton,
  Typography,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';
import { io } from 'socket.io-client';
import PageHeader from '../../../components/common/PageHeader';



const socket = io(`${process.env.REACT_APP_API_URL}`);

const O365Licenses = ({data}) => {
    const [filteredO365Licenses, setfilteredO365Licenses] = useState([]);

  const { data: o365Licenses = [], loading, error } = useSelector((state) => state.o365.licenses);

  const { selectedOrganization } = useOrganizationSelect();


    const dispatch = useDispatch();
    
    useEffect(() => {
      

    if (selectedOrganization) {
      setfilteredO365Licenses(o365Licenses.filter(
        (item) => item.organizationName === selectedOrganization
      ));
    } else {
      setfilteredO365Licenses(o365Licenses);
    }
    socket.on("o365:licenseUpdated", () => {
        console.log("📡 Événement reçu : o365:licenseUpdated");
        dispatch(fetchO365Licenses()); 
       
      });
       return () => {
          socket.disconnect();
        };
  }, [selectedOrganization, o365Licenses, dispatch]);

  // useEffect(() => {
  //   // fetchO365Licenses();
  //   // socket.on("o365:licenseUpdated", () => {
  //   //   console.log("📡 Événement reçu : o365:licenseUpdated");
  //   //   fetchO365Licenses(); // 🔁 recharge les données
  //   // });
  //   // return () => {
  //   //   socket.off("o365:licenseUpdated");
  //   // };

  // }, [selectedOrganization]);

    const columns = useMemo(
      () => [
        {
          id: 'licenses', //id used to define `group` column
          columns: [
            {
              accessorFn: (row) => `${row.licenseName}`, //accessorFn used to join multiple data into a single cell
              id: 'name', //id is still required when using accessorFn instead of accessorKey
              header: 'Nom',
              size: 250,
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
              ),
              filterVariant: 'multi-select',
            },
            {
              accessorKey: 'used', //hey a simple column for once
                header: 'Utilisé',
                size: 100,
                },

                {
                accessorFn: (row) => {
                  if (!row.nextCycleDateTime) return '';
                  const date = new Date(row.nextCycleDateTime);
                  const pad = (n) => n.toString().padStart(2, '0');
                  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
                },
                id: 'nextCycleDateTime',
                header: 'Date de renouvellement',
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue();
                  return (
                  <Box
                  sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  }}
                  >
                  {value}
                  </Box>
                  );
                },
                },
                {
                accessorKey: 'total', //hey a simple column for once
              header: 'Total',
              size: 100,
            },
            {
              accessorKey: 'organizationName', //hey a simple column for once
              header: 'Client',
              filterVariant: 'autocomplete',
            },
          ]}
      ],
      [],
    );
    
  
    const table = useMaterialReactTable({
    enableGlobalFilter: true,
    enableColumnFilters: true,

        localization: MRT_Localization_FR,
      columns,
      data: filteredO365Licenses ? filteredO365Licenses : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      enableColumnOrdering: true,
      enableGrouping: true,
      enableColumnPinning: true,
      enableFacetedValues: true,
      // enableRowSelection: true,
      initialState: {
        density:"compact",
        showColumnFilters: true,
        showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
        pagination: {
          pageSize: 50,

        }
      },
      paginationDisplayMode: 'pages',
      positionToolbarAlertBanner: 'bottom',
      positionGlobalFilter:"left",
      muiSearchTextFieldProps: {
        variant: 'outlined',
        fullWidth: true,
        
      },
      muiPaginationProps: {
      color: 'secondary',
      rowsPerPageOptions: [50, 100, 150],
      shape: 'rounded',
      variant: 'outlined',
      },
      renderDetailPanel: ({ row }) => (
      <Box
        sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-around',
        left: '30px',
        maxWidth: '1000px',
        position: 'sticky',
        width: '100%',
        }}
      >
        <Box sx={{ textAlign: 'center', width: '100%' }}>
        <DataGrid
          rows={row.original.matchedUsers.map((user, index) => ({
          id: index,
          userPrincipalName: user.userPrincipalName,
          displayName: user.displayName,
          }))}
          disableColumnResize
          density="compact"
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
          }
          columns={[
            { field: 'displayName', headerName: 'Nom', flex: 1 },
          { field: 'userPrincipalName', headerName: 'Email', flex: 1 },
          ]}
          pageSize={5}
          rowsPerPageOptions={[5]}
          slotProps={{
            filterPanel: {
              filterFormProps: {
                logicOperatorInputProps: {
                  variant: 'outlined',
                  size: 'small',
                },
                columnInputProps: {
                  variant: 'outlined',
                  size: 'small',
                  sx: { mt: 'auto' },
                },
                operatorInputProps: {
                  variant: 'outlined',
                  size: 'small',
                  sx: { mt: 'auto' },
                },
                valueInputProps: {
                  InputComponentProps: {
                    variant: 'outlined',
                    size: 'small',
                  },
                },
              },
            },
          }}
        />
        </Box>
      </Box>
      ),
    });
  
  
    return (
       <Box>
          <PageHeader section="O365" title="Licences" sx={{ my: 1 }} />
        
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={600} />
        ) : o365Licenses.length === 0 ? (
          <Box sx={{ textAlign: 'center', p: 2 }}>
            <Typography variant="h6" color="textSecondary">
              Aucune donnée disponible
            </Typography>
          </Box>
        ) : (
          <MaterialReactTable table={table} />
        )}
      </Box>
       
      )

};

export default O365Licenses;
